export const MAIN_SLIDER_MENU_ID = 'ow-navigation-menu';
export const NOTE_INPUT_ID = 'ow-notes-input';
